import { PayerConfigItem } from "./payer-config-item";

export class UpdatePayerRequest {
    Item: PayerConfigItem;
    AliasIDs: string;
    AliasNames: string;
    Note: string;
}
